import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { defaultOrdersDispatchData, getOrdersDispathById, viewInvoice, updateLrOrdersDispath } from '@/api/orders-dispatches';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import { Action } from 'vuex-module-decorators';
import router from '@/router';
import { AdminModule } from '@/store/modules/admin';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, defaultOrdersDispatchData);
    this.loading = false;
    this.rules = {
      lrNumber: {
        required: true,
        trigger: 'blur',
        message: 'This field is required'
      },
      lrDate: {
        required: true,
        trigger: 'blur',
        message: 'This field is required'
      }
    };
    this.loggedInAdmin = null;
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    this.loggedInAdmin = AdminModule;
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, defaultOrdersDispatchData);
    }
    this.tempTagView = Object.assign({}, this.$route);
  }
  isDateAllowed(time) {
    return time.getTime() > Date.now();
  }
  async fetchData(id) {
    try {
      const data = await getOrdersDispathById(id);
      this.formData = data;
      // Just for test
      const title = 'LR Detail - #' + this.formData.id;
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  async saveForm() {
    try {
      this.loading = true;
      // format date
      this.formData.lrDate = this.$moment(this.formData.lrDate).format('YYYY-MM-DD');
      let response = {
        status: 'info',
        message: 'Try again!'
      };
      if (this.isEdit) {
        const dataToUpdate = {
          lrNumber: this.formData.lrNumber,
          lrDate: this.formData.lrDate
        };
        response = await updateLrOrdersDispath(this.formData.id, dataToUpdate);
        // create invoice (add following line & import viewInvoice function
        await viewInvoice(this.formData.id);
      }
      this.loading = false;
      this.$notify({
        title: response.status,
        message: response.message,
        type: response.status,
        duration: 2000
      });
      router.push('/orders-dispatches/list');
    } catch (err) {
      this.loading = false;
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'OrdersDispatchDetail',
  components: {}
})], default_1);
export default default_1;